<template>
  <v-menu
    ref="menu"
    v-bind="$attrs"
    v-model="menu"
    :close-on-content-click="false"
    :value="value"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="mdi-clock-time-four-outline"
        clearable
        readonly
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-time-picker
      v-bind="$attrs"
      v-if="menu"
      v-model="time"
      full-width
      format="24hr"
      :min="min"
      @click:minute="updateValue(time)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "MenuTimePicker",
  props: ["label", "value", "disabled", "min", "format"],
  data: () => ({
    menu: null,
    time: null
  }),
  methods: {
    updateValue(value) {
      this.time = value;
      this.$refs.menu.save(value);
      this.$emit("input", value);
    }
  },
  computed: {},
  watch: {
    value(val) {
      // this.updateValue(val);v
      this.time = val;
      this.$refs.menu.save(val);
    }
  },
  created() {
    if (this.value) {
      this.time = this.value;
    }
    //this.date = moment().format("YYYY-MM-DD");
  }
};
</script>
